import { forwardRef } from "react";

import StatusBadge from "../StatusBadge/StatusBadge";
import { SelectItem } from "./EntrySelectItem.styled";
import useNonMaritime from "../../../hooks/useNonMaritime";

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  status: number;
  autosave: number;
  value: string;
}

export const EntrySelectItem = forwardRef<HTMLDivElement, ItemProps>(
  ({ label, status, autosave, value, ...others }: ItemProps, ref) => {
    return (
      <SelectItem ref={ref} {...others}>
        {label}
        <StatusBadge
          id={value}
          status={status}
          size={"sm"}
          autosave={autosave}
        />
      </SelectItem>
    );
  },
);

export const EntrySelectItemWidget = forwardRef<HTMLDivElement, ItemProps>(
  ({ label, status, autosave, value, ...others }: ItemProps, ref) => {
    return (
      <SelectItem ref={ref} {...others}>
        {label}
      </SelectItem>
    );
  },
);
